export default __webpack_public_path__ + "static/media/YAS0150.34I106404_-16868_0.56920bd9.jpg";